<template>
  <div class="page-main-tab-bar user-main">
    <div class="header">
      <router-link
        v-if="Id"
        :to="{ name: 'personal', params: { id: userInfo.Id || 0 }}">
        <Avatar class="avatar" :size="40" :src="userInfo.Avatar"></Avatar>
      </router-link>
      <Avatar v-else class="avatar" :size="40" :src="userInfo.Avatar"></Avatar>
      <div v-if="Id" class="icon-list">
        <router-link :to="{ name: 'set' }">
          <van-icon class="setting" color="#fff" size="20" name="setting" />
        </router-link>
        <router-link :to="{ name: 'noticeList' }">
          <van-icon
            class="bell"
            name="bell"
            color="#fff"
            size="20"
            :info="NoticeNum > 99 ? '99+' : NoticeNum ? NoticeNum : ''"
          />
        </router-link>
      </div>
      <div class="user-message">
        <div class="signin_btn" @click="goSignin">签到领积分</div>
        <div v-show="!Id" class="not-login">
          <div @click="wxLogOnAction">
            <p class="text-big-more text-bold">未登录</p>
            <p class="text-normal text-gray">登录体验更多内容</p>
          </div>
        </div>
        <div v-show="Id" class="login">
          <h3>{{ userInfo.NickName }}</h3>
          <svg
            v-if="userInfo.Type === 1"
            class="svg-icon author-icon"
            aria-hidden="true"
          >
            <use xlink:href="#icon-qiye1" />
          </svg>
          <svg
            v-if="userInfo.Type === 14"
            class="svg-icon author-icon"
            aria-hidden="true"
          >
            <use xlink:href="#icon-zhuanjia" />
          </svg>
          <svg
            v-if="userInfo.Type === 22"
            class="svg-icon author-icon"
            aria-hidden="true"
          >
            <use xlink:href="#icon-hangjia" />
          </svg>
          <div class="login-info">
            <div>
              <router-link
                :to="{ name: 'articleList', params: { title: 'article' } }"
              >
                <p>{{ userInfo.PublishQuantity }}</p>
                <span>发布</span>
              </router-link>
            </div>
            <div>
              <router-link :to="{ name: 'fans', params: { title: 'follow' } }">
                <p>{{ userInfo.FollowQuantity }}</p>
                <span>关注</span>
              </router-link>
            </div>
            <div>
              <router-link :to="{ name: 'fans', params: { title: 'fans' } }">
                <p>{{ userInfo.FollowedQuantity }}</p>
                <span>粉丝</span>
              </router-link>
            </div>
            <div @click="hasGoodPop">
              <p>{{ userInfo.GoodQuantity }}</p>
              <span>获有用</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="zhan"></div>
      <div class="list">
        <van-cell-group class="line" :border="false">
          <van-cell
            title="我的收藏"
            title-style="margin-left:15px;"
            icon="star"
            is-link
            :to="{ name: 'behaviour', params: { title: 'collect' } }"
          />
          <van-cell
            title="我的评论"
            title-style="margin-left:15px;"
            icon="comment"
            is-link
            :to="{ name: 'behaviour', params: { title: 'comment' } }"
          />
          <van-cell
            title="我的有用"
            title-style="margin-left:15px;"
            is-link
            :to="{ name: 'behaviour', params: { title: 'have' } }"
          >
            <!-- <van-icon class="md-icon van-icon van-icon-comment van-cell__left-icon" slot="icon" class-prefix="icon" name="lingdang" size="20"/> -->
            <i
              slot="icon"
              class="md-icon iconfont icon-youyong van-cell__left-icon"
            ></i>
          </van-cell>
        </van-cell-group>
        <van-cell-group class="line" :border="false">
          <van-cell
            title="我的关注"
            title-style="margin-left:15px;"
            icon="like"
            is-link
            :to="{ name: 'fans', params: { title: 'follow' } }"
          />
          <van-cell
            title="我的粉丝"
            title-style="margin-left:15px;"
            icon="friends"
            is-link
            :to="{ name: 'fans', params: { title: 'fans' } }"
          />
        </van-cell-group>
        <van-cell-group class="line" :border="false">
          <van-cell
            title="我打赏的文章"
            title-style="margin-left:15px;"
            is-link
            :to="{ name: 'paymentArticle', params: { title: 'reward' } }"
          >
            <i
              slot="icon"
              class="md-icon iconfont icon-dashang van-cell__left-icon"
            />
          </van-cell>        
          <van-cell
            title="我付费的文章"
            title-style="margin-left:15px;"
            is-link
            :to="{ name: 'paymentArticle', params: { title: 'payment' } }"
          >
            <i
              slot="icon"
              class="md-icon iconfont icon-fufeibaoming van-cell__left-icon"
            />
          </van-cell>        
        </van-cell-group>
        <van-cell-group :border="false">
          <van-cell
            title="我的名片"
            title-style="margin-left:15px;"
            is-link
            :to="{ name: 'mycard' }"
          >
            <i
              slot="icon"
              class="md-icon iconfont icon-mingpian van-cell__left-icon"
            />
          </van-cell>
          <van-cell
            title="账户收益"
            title-style="margin-left:15px;"
            is-link
            :to="{ name: 'accountFlow'}"
          >
            <i
              slot="icon"
              class="md-icon iconfont icon-fufeibaoming van-cell__left-icon"
            />
          </van-cell>            
          <van-cell
            title="消息通知"
            title-style="margin-left:15px;"
            icon="bell"
            is-link
            :to="{ name: 'noticeList' }"
          />
        </van-cell-group>
      </div>
      <div class="zhan-bottom"></div>
    </div>
    <van-popup v-model="showGoodPop" get-container="body">
      <div class="goodQuantity">
        <div class="goodQuantity-content">
          <p class="text-big-more text-bold">{{ userInfo.NickName }}</p>
          <p class="text-gray">
            共获得<span class="text-red"
              >{{ userInfo.GoodQuantity }}个有用</span
            >
          </p>
          <svg class="svg-icon youyong-icon" aria-hidden="true">
            <use xlink:href="#icon-youyong-" />
          </svg>
        </div>
        <van-button
          class="btn"
          type="primary"
          square
          @click="showGoodPop = false"
          >好的</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Cms } from '@/api'
import Avatar from '@/components/avatar'
export default {
  name: 'user',
  components: { Avatar },
  data() {
    return {
      showGoodPop: false,
      Id: this.$mdUtils.getUserInfo('Id'),
      NoticeNum: 0,
      userInfo: {
        NickName: '',
        PublishQuantity: 0,
        FollowQuantity: 0,
        FollowedQuantity: 0,
        GoodQuantity: 0,
        Type: 1
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      if (this.Id) {
        let userInfo = await this.getUserHomePage(this.Id)
        let extendInfo = await this.getUserExtendByUserId(this.Id)
        this.NoticeNum = await this.getNoticeNum(this.Id)
        this.userInfo = { extendInfo, ...userInfo }
        this.$mdUtils.setUserInfo(this.userInfo)
      }
    },
    async getUserHomePage(Id) {
      return await this.$api(Cms.GetUserHomePage, { Id })
    },
    async getUserExtendByUserId(UserId) {
      return await this.$api(Cms.UserGetUserExtendByUserId, { UserId })
    },
    async getNoticeNum(Id) {
      return await this.$api(Cms.NoticeGetUnReadRecord, { UserId: Id })
    },
    wxLogOnAction() {
      this.$mdUtils.wxLogOnAction()
    },
    hasGoodPop() {
      this.showGoodPop = true
    },
    goSignin() {
      this.$router.push({name: 'Signin'})
    }
  }
}
</script>
<style lang="scss">
.user-main {
  .van-cell {
    padding: 15px 20px;
    font-size: $font-size-big;
  }
  .van-info {
    word-break: normal;
  }
}
</style>


<style lang="scss" scoped>
.header {
  position: relative;
  top: 0;
  left: 0;
  height: 120px;
  background: linear-gradient(270deg, rgba(43, 50, 63, 1) 0%, rgba(82, 93, 112, 1) 100%);
  .avatar {
    width: 60px;
    height: 60px;
    z-index: 101;
    overflow: hidden;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .user-message {
    position: absolute;
    top: 55px;
    left: 50%;
    transform: translateX(-50%);
    width: 330px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 10px;
    z-index: 100;
  }
}
.content {
  .zhan {
    height: 98px;
    width: 100%;
  }
  .list {
    position: relative;
    background: $gray;
  }
  .zhan-bottom {
    height: $bottom-h;
    width: 100%;
  }
}

.not-login {
  margin-top: 58px;
  text-align: center;
}

.login {
  position: relative;
  top: 0;
  left: 0;
  margin-top: 30px;
  text-align: center;
  h3 {
    margin: 0;
    padding: 0 10px;
    font-size: $font-size-big;
    font-weight: normal;
    @include text-overflow;
  }
  &-tag {
    margin-top: 5px;
    font-size: $font-size-small;
    background-color: $orange !important;
    color: #fff;
  }
  &-info {
    display: flex;
    border-top: 1px solid $gray-shallow;
    margin-top: 15px;
    padding: 0 0 15px;
    & > div:last-child {
      border: transparent;
    }
    & > div {
      flex: 1;
      margin-top: 10px;
      border-right: 1px solid $gray-shallow;
      overflow: hidden;
      p {
        margin: 0;
        padding: 0 10px;
        font-size: $font-size-big;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        font-size: $font-size-small;
      }
    }
  }
}
.icon-list {
  display: flex;
  justify-content: space-between;
  padding: 20px 21px;
}
.goodQuantity {
  position: relative;
  left: 0;
  top: 0;
  width: 300px;
  height: 230px;
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  border-radius: 10px;
  position: relative;
  &-content {
    width: 85%;
    top: 24px;
    left: 0;
    margin: 0 auto;
    text-align: center;
    img {
      width: 54px;
      height: 60px;
      margin: 0 auto;
    }
    .youyong-icon {
      width: 100px;
      height: 100px;
      margin: 0 auto;
      margin-top: -15px;
    }
  }
  .btn {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    font-size: $font-size-big;
  }
}
.author-icon {
  width: 36px;
  height: 26px;
}

.md-icon {
  font-size: 20px;
}

.signin_btn {
  position: absolute;
  top: 0;
  right: 10px;
  background: $red;
  color: #fff;
  border-radius: 0 0 8px 8px;
  padding: 3px 12px;
  cursor: pointer;
}
</style>
